module.exports = __webpack_public_path__ + "static/media/pic1.56d5e0d9.jpg";